import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getQuestionBanksByFolder, getQuestionBanksInstitutionByFolder } from "../helper/apicalls/questionBank";
import CommonPagination from "../components/common/CommonPagination";
import "../styles/MaterialFolder.scss";

const QuestionBankFolder = () => {
  const { folderid } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const limit = 10;

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    } catch (e) {
      return dateString;
    }
  };

  useEffect(() => {
    setPage(1);
  }, [folderid, location.search]);

  useEffect(() => {
    const fetchItems = async () => {
      if (!folderid) return;
      try {
        setLoading(true);
        const searchParams = new URLSearchParams(location.search);
        const isInstitution = searchParams.get("type") === "institution";

        const res = isInstitution
          ? await getQuestionBanksInstitutionByFolder({ folderId: folderid, page, limit })
          : await getQuestionBanksByFolder({ folderId: folderid, page, limit });

        const data = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res)
            ? res
            : [];
        setItems(data);

        const calculatedTotal = res?.total_pages || (res?.total && res?.limit ? Math.ceil(res.total / res.limit) : 1);
        setTotalPages(calculatedTotal);
        setTotalItems(res?.total || data.length);

        if (res?.folder_name) {
          Cookies.set("currentFolderName", res.folder_name);
        }
      } catch (e) {
        console.error("Failed to load question banks for folder", e);
        setItems([]);
        setTotalPages(1);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    };
    fetchItems();
  }, [folderid, location.search, page]);

  const handleOpenTest = (bank) => {
    if (!bank) return;
    const bankId = bank.id || bank._id;
    if (!bankId) return;
    const searchParams = new URLSearchParams(location.search);
    const isInstitution = searchParams.get("type") === "institution";
    navigate(`/question-bank-folder/${folderid}/${bankId}${isInstitution ? "?type=institution" : ""}`);
  };

  return (
    <div className="materials-page">
      {loading ? (
        <div className="materials-loading">Loading question banks...</div>
      ) : items.length === 0 ? (
        <div className="material-folder-empty">No question banks found.</div>
      ) : (
        <>
          <div className="practice-test-grid">
            {items.map((qb) => (
              <div
                key={qb.id || qb._id}
                className="material-folder-item question-bank-card"
                onClick={() => handleOpenTest(qb)}
              >
                <div className="question-bank-card__header">
                  <h3 className="question-bank-card__title">
                    {qb.name || qb.title || "Untitled Question Bank"}
                  </h3>
                </div>
                <div className="question-bank-card__footer">
                  <span className="question-bank-card__date">
                    Created: {formatDate(qb.created_at)}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <CommonPagination
            count={totalPages}
            page={page}
            onChange={(e, value) => setPage(value)}
            totalItems={totalItems}
            currentCount={items.length}
            itemLabel="Question Banks"
          />
        </>
      )}
    </div>
  );
};

export default QuestionBankFolder;
